import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";
import { Title } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

const StyledBoxSubtitle = styled(Title).attrs<{ "data-automation-box-subtitle"?: boolean }>((props) => ({
    "data-automation-box-subtitle": true,
}))`
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.2px;
    text-align: left;
    color: ${rgba(carbon[500], 0.8)};
`;
StyledBoxSubtitle.displayName = "StyledBoxSubtitle";
export default StyledBoxSubtitle;

export const Subtitle = styled.span`
    ${setFontVariant("caption", carbon[400])};
`;

export const BoldSubtitle = styled.span`
    ${setFontVariant("subtitle1", carbon[500])};
    width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
